import { colorMap } from './color-map';
import { LabelColor } from '../configs/label-color';
import { LabelKey } from '../configs/label-key';

export const styleMap = {
  [LabelKey.Draft]: colorMap[LabelColor.Grey],
  [LabelKey.ReadyForVerification]: colorMap[LabelColor.Orange],
  [LabelKey.OnVerification]: colorMap[LabelColor.Blue],
  [LabelKey.OnDigitalization]: colorMap[LabelColor.Purple],
  [LabelKey.ReadyForSale]: colorMap[LabelColor.Cyan],
  [LabelKey.OnSale]: colorMap[LabelColor.LightGreen],
  [LabelKey.OnAuction]: colorMap[LabelColor.Emerald],
  [LabelKey.Sold]: colorMap[LabelColor.Slate],

  [LabelKey.Published]: colorMap[LabelColor.Emerald],
  [LabelKey.Unverified]: colorMap[LabelColor.Grey],
  [LabelKey.Verified]: colorMap[LabelColor.Blue],
  [LabelKey.Copy]: colorMap[LabelColor.Dark],
  [LabelKey.Pending]: colorMap[LabelColor.Orange],
  [LabelKey.Other]: colorMap[LabelColor.Grey],
  [LabelKey.Online]: colorMap[LabelColor.Emerald],

  [LabelKey.ReadyForMint]: colorMap[LabelColor.Emerald],
  [LabelKey.MetadataUploading]: colorMap[LabelColor.LightBlue],
  [LabelKey.MetadataUploaded]: colorMap[LabelColor.LightBlue],
  [LabelKey.Minting]: colorMap[LabelColor.Emerald],
  [LabelKey.MintingFailed]: colorMap[LabelColor.Red],

  [LabelKey.Individual]: colorMap[LabelColor.Blue],
  [LabelKey.Group]: colorMap[LabelColor.Orange],

  [LabelKey.Active]: colorMap[LabelColor.Emerald],
  [LabelKey.Canceled]: colorMap[LabelColor.Red],
  [LabelKey.Expired]: colorMap[LabelColor.Amber],
  [LabelKey.Finalizing]: colorMap[LabelColor.Amber],

  [LabelKey.DigitalOriginalPurchase]: colorMap[LabelColor.Fuchsia],
  [LabelKey.PhysicalOriginalPurchase]: colorMap[LabelColor.Teal],
  [LabelKey.PhysicalAndDigitalOriginalPurchase]: colorMap[LabelColor.Indigo],
} satisfies {
  [key in LabelKey]: string;
};
